import { IconButton } from 'library/buttons';
import { MinusIcon, PlusIcon } from 'library/icons';
import { Tooltip } from 'library/tooltip';
import Slider from 'rc-slider';
import { FC } from 'react';
import { useZoomableContext } from '../../context/ZoomableContext';

interface ZoomableControlsProps {
    zoomInLabel?: string;
    zoomOutLabel?: string;
}

const ZoomableControls: FC<ZoomableControlsProps> = (props) => {
    const { zoomInLabel = 'Zoom in', zoomOutLabel = 'Zoom out' } = props;

    const { state, zoomOut, zoomIn, zoomTo } = useZoomableContext();

    return (
        <div className="flex items-center gap-6">
            <Tooltip placement="top" content={zoomOutLabel} onClick={() => zoomOut()}>
                <IconButton className="opacity-70" color="secondary">
                    <MinusIcon width="14" height="8" />
                </IconButton>
            </Tooltip>

            <div className="w-[220px]">
                <Slider
                    styles={{
                        handle: {
                            borderColor: 'rgba(255,255,255,0.9)',
                            backgroundColor: 'rgba(255,255,255,1)',
                            boxShadow: 'none',
                            height: 20,
                            width: 20,
                            marginTop: -7,
                            opacity: 1,
                        },
                        rail: { backgroundColor: 'rgba(255,255,255,0.3)', height: 6 },
                        track: { backgroundColor: 'rgba(255,255,255,0.6)', height: 6 },
                    }}
                    min={1}
                    max={14}
                    step={0.1}
                    value={state.k}
                    onChange={(val) => zoomTo(val as number)}
                />
            </div>

            <Tooltip placement="top" content={zoomInLabel}>
                <IconButton className="opacity-70" color="secondary" onClick={() => zoomIn()}>
                    <PlusIcon width="14" height="14" />
                </IconButton>
            </Tooltip>
        </div>
    );
};

export default ZoomableControls;
